import { Tabs } from "@chakra-ui/react";
import useThemeColors from "../../hooks/useThemeColors";

interface TabItem {
  id: string;
  label: string;
}

interface CustomTabListProps {
  items: TabItem[];
  colorPalette?: string;
  children: React.ReactNode | ((item: TabItem) => React.ReactNode);
}

export default function CustomTabList({ items, children }: CustomTabListProps) {
  const colors = useThemeColors();
  return (
    <Tabs.Root
      variant="enclosed"
      colorPalette={colors.schoolAccent.primary}
      defaultValue={items[0].id}
    >
      <Tabs.List
        borderRadius="md"
        p={1}
        bg={colors.background.tertiary}
        overflowX="auto"
        whiteSpace="nowrap"
        css={{
          "::WebkitScrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
        gap={1}
      >
        {items.map((item) => (
          <Tabs.Trigger
            value={item.id}
            key={item.id}
            borderRadius="md"
            fontWeight="medium"
            fontSize={{ base: "sm", md: "md" }}
            minW={{ base: "100px", sm: "120px", md: "auto" }}
            maxW={{ base: "140px", sm: "160px", md: "none" }}
            flexShrink={0}
            _selected={{
              bg: colors.background.sidebar,

              transform: "scale(1.02)",
              _hover: {
                bg: colors.background.sidebar,
              },
            }}
            _hover={{
              bg: colors.background.secondary,
              transform: "scale(1.01)",
            }}
            transition="all 0.2s"
            textAlign="center"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {item.label}
          </Tabs.Trigger>
        ))}
      </Tabs.List>
      {items.map((item) => (
        <Tabs.Content key={item.id} value={item.id} p={0} pt={5}>
          {typeof children === "function" ? children(item) : children}
        </Tabs.Content>
      ))}
    </Tabs.Root>
  );
}
